import "./CustomNode.scss";

import DragHandle from "../common/DragHandle";

const CustomNode = ({ color, children }) => {
  return (
    <div className="customNode" style={{ backgroundColor: color }}>
      <DragHandle />
      {children}
    </div>
  );
};
export default CustomNode;
